type Scalar = string | number | boolean | null | undefined

type ScalarDict = Record<string, Scalar>
export default ScalarDict
